import { connectRouter, routerMiddleware as createRouterMiddleware } from 'connected-react-router'
import { createBrowserHistory }                                      from 'history'
import { applyMiddleware, compose, createStore, Middleware }         from 'redux'
import createSagaMiddleWare                                          from 'redux-saga'

import reducer                                                   from './ducks'
import { createStorageMiddleWare, loadState, requestMiddleware } from './middlewares'
import rootSaga                                                  from './sagas'

const browserHistory = createBrowserHistory()
const storageMiddleware = createStorageMiddleWare(window.localStorage)
const routerMiddleWare = createRouterMiddleware(browserHistory)
const sagaMiddleware = createSagaMiddleWare()

/* tslint:disable-next-line */
const reduxDevtoolsCompose = window[ '__REDUX_DEVTOOLS_EXTENSION_COMPOSE__' ]

const composeEnhancers = reduxDevtoolsCompose || compose

const savedState = loadState(window.localStorage) || {}

const middlewares: Middleware [] = [
  storageMiddleware,
  sagaMiddleware,
  routerMiddleWare,
  requestMiddleware,
]

const store = createStore(
  connectRouter(browserHistory)(reducer),
  savedState,
  composeEnhancers(
    applyMiddleware(...middlewares),
  ),
)

sagaMiddleware.run(rootSaga)

export const history = browserHistory
export default store



// WEBPACK FOOTER //
// ./src/redux/createStore.ts